import { Box, Button } from '@mui/material';
import PurpleButton from './PurpleButton';

export default function FormButtonLayout({
    onDelete,
    showSkillsPage,
    setShowSkillsPage,
    selected,
    handleSave
}) {
    return (
        <Box display="flex" gap={2}>
            <PurpleButton label="Save" onClick={handleSave} />

            {typeof showSkillsPage !== 'undefined' && typeof setShowSkillsPage === 'function' && (
                <PurpleButton
                    label={showSkillsPage ? "Form" : "Skills"}
                    onClick={() => setShowSkillsPage((prev) => !prev)}
                />
            )}

            {selected && (
                <Button
                    variant="outlined"
                    color="error"
                    onClick={async () => {
                        if (
                            window.confirm(
                                'Are you sure you want to delete? This action cannot be undone.'
                            )
                        ) {
                            await onDelete()
                        }
                    }}
                >
                    Delete
                </Button>
            )}
        </Box>
    );
}
